import { render, staticRenderFns } from "./Coursestats.vue?vue&type=template&id=0058b591&scoped=true&"
import script from "./Coursestats.vue?vue&type=script&lang=js&"
export * from "./Coursestats.vue?vue&type=script&lang=js&"
import style0 from "./Coursestats.vue?vue&type=style&index=0&id=0058b591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058b591",
  null
  
)

export default component.exports